import videojs from 'video.js';

const Button = videojs.getComponent('Button');

/**
 * An overlayable button that handles paging backward on the overlay.
 */
export default class OverlayBackButton extends Button {
  constructor(player, options) {
    super(player, options);

    this.addClass('vjs-icon-previous-item');
    this.addClass('vjs-overlay-nav-button');
    this.addClass('vjs-overlay-previous-button');
    this.controlText(player.localize('Previous Page of Videos'));
  }

  handleClick() {
    this.player_.trigger('controls:overlay:back');
  }
}
